<div class="rounded-2xl bg-neutral-100 p-6">
  <h3 class="mb-4">Controles</h3>

  <core-table
    [data]="controls"
    [headers]="[
      {label: 'Control', customTemplate: controlNameTpl},
      {label: 'Estado actual', customTemplate: controlStatusTpl, options: { align: 'center', verticalAlign: 'middle'}},
      {label: 'Decisión', customTemplate: controlDecisionTpl, options: { verticalAlign: 'middle'}},
      {label: 'Asociación', customTemplate: controlLinkTpl, options: { verticalAlign: 'middle'}},
    ]"
  />
</div>

<div class="rounded-2xl bg-neutral-100 p-6">
  <h3 class="mb-4">Controles permanentes (contexto)</h3>

  <core-table
    [data]="permanentControls"
    [headers]="[
      {label: 'Control', customTemplate: controlNameTpl},
      {label: 'Estado', customTemplate: controlStatusTpl, options: { align: 'center', verticalAlign: 'middle'}},
      {label: 'Asociación', customTemplate: controlLinkTpl, options: { verticalAlign: 'middle'}},
    ]"
  />
</div>

<div class="w-full flex flex-row items-center gap-4">
  <button (click)="onSubmit()"
          [disabled]="isSubmittingPhase"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
          style="border-radius: 0.5rem;padding: 0.5rem 1rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/save.svg">
    <span class="hidden lg:block cd-text-md truncate">Continuar</span>
  </button>
</div>

<ng-template #controlNameTpl let-item>
  <div class="max-w-[28rem]">
    <div class="cd-text-b1 text-left text-neutral-900 truncate">{{ item.name }}</div>
    <div class="cd-text-b4 truncate text-neutral-500">{{ item.description || 'Sin descripción' }}</div>
  </div>
</ng-template>

<ng-template #controlDecisionTpl let-item>
  <div class="flex flex-row flex-wrap gap-2">
    @for (option of decisionOptions(item); track option) {
      <button
        type="button"
        (click)="setDecision(item, option)"
        [disabled]="isUpdating(item)"
        [class.btn-primary]="selectedDecision(item) === option"
        [class.btn-primary-soft]="selectedDecision(item) !== option"
        class="btn !px-2 !py-1">
        @if (option === 'inherit') { Heredar }
        @if (option === 'promote') { Promocionar }
        @if (option === 'finalize') { Finalizar }
      </button>
    }
  </div>
</ng-template>

<ng-template #controlLinkTpl let-item>
  @if (item.task || item.affects) {
    <div class="flex flex-wrap gap-2">
      @if (item.task) {
        <span class="outline primary !py-0 !px-2 cd-text-b5">{{ item.task }}</span>
      }
      @if (conceptTags(item).length) {
        @for (tag of conceptTags(item); track tag) {
          <span class="outline secondary !py-0 !px-2 cd-text-b5">{{ tag }}</span>
        }
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-700">Sin asociación</span>
  }
</ng-template>

<ng-template #controlStatusTpl let-item>
  <span class="outline warning !py-0 !px-2 cd-text-b5">{{ statusLabel(item) }}</span>
</ng-template>
